<template>
  <div class="home-section">
    <div class="tile is-ancestor" v-if="projects.length > 0">
      <div
        class="tile is-parent"
        v-for="(project, index) in projects"
        :key="index"
        style="cursor: pointer"
        @click="projectSelected(project)"
      >
        <article class="tile is-child box">
          <p class="title">{{ project.projectName }}</p>
          <p class="subtitle">{{ project.project }}</p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "InternalPage",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: "user",
      projects: state => state.globalStore.projects
    })
  },
  mounted() {
    this.$buefy.snackbar.open({
      message: "Welcome back!",
      queue: false
    });
  },
  methods: {
    ...mapActions({
      loading: "SET_SCREEN_LOADING",
      fetchProjectUsers: "globalStore/fetchUsersFromProject",
      updateActiveFields: "globalStore/updateActiveFields"
    }),
    projectSelected(project) {
      // this.$store.commit("SET_SCREEN_LOADING", true);
      this.updateActiveFields(project);
      if (project.usersFetched) {
        this.goHome();
      } else {
        // fetch users from api
        let _this = this;
        this.fetchProjectUsers(project.project).then(ans => {
          if (ans) {
            //go to home page
            _this.goHome();
          }
        });
      }
    },
    goHome() {
      this.loading(false);
      this.$router.push({ name: "home" });
    }
  }
};
</script>
